import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import {
  IpoLanguageService,
  IpoTranslateArrayPipe,
  IpoTranslatePipe,
} from '@ip-only/front-end-library';
import { RolloutProgressReportEntities } from '../../../../shared/self-inspection-reports/service/entities';
import { MultiHpPointProperties } from '../../../span-progress-entities';
import { MultiPointModalData } from '../../report-modal.service';
import { buildRolloutReportUrl } from '../../../span-progress-view/popup-content/popup-pdf.utils';
import { hPColumns } from './hp-table-columns';

@Component({
  selector: 'app-hp-table',
  templateUrl: './hp-table.component.html',
  styleUrl: './hp-table.component.scss',
  providers: [IpoTranslateArrayPipe],
  standalone: false,
})
export class HpTableComponent {
  @Input() multiPointData: MultiPointModalData;
  @Output() dismiss = new EventEmitter();

  columns = hPColumns;
  language$ = this.languageService.getLanguage$();

  constructor(
    private readonly languageService: IpoLanguageService,
    private readonly translate: IpoTranslatePipe,
    private readonly router: Router,
  ) {}

  closeModal() {
    this.dismiss.emit();
  }

  openHpReportPage(hp: MultiHpPointProperties) {
    this.closeModal();
    const sourceKey = hp.properties.sourceKey ?? '';
    window.open(
      buildRolloutReportUrl(
        this.router.url,
        RolloutProgressReportEntities.v3.MarkerTypes.HP,
        sourceKey,
      ),
      '_blank',
    );
  }

  setStatusString(hp: MultiHpPointProperties) {
    switch (hp.status) {
      case 'DONE':
        return this.translate.transform('hpReportModal.pill.done');
      case 'DONE_WITHOUT_IMAGES':
        return this.translate.transform('hpReportModal.pill.doneWithoutImages');
      default:
        return this.translate.transform('hpReportModal.pill.notDone');
    }
  }
}
